<template>
  <div class="wrapper">
    <div class="text-wrapper">
      <img src="../CloudDesktopFileSubmit/assets/upload.svg" />
      <div class="text">{{ content.fileName }}</div>
    </div>
    <div class="button" @click="desktopUploadFile">上传至云桌面</div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';
import { Environment } from '@/store/modules/common/types/index';
import { namespace } from 'vuex-class';
import { desktopFileUploadAuto, desktopFileUpload } from '../PracticeCourt/initSpecial';

const userModule = namespace('common');

@Component({})
export default class Index extends Vue {
  @Prop({ type: Object }) content!: Content & {
    desktopId: string;
    fileName: string;
    src: string;
  };
  @userModule.State('environment') environment!: Environment;

  get courseId() {
    const courseId =
      this.environment && this.environment.kind === 'public-preview'
        ? this.environment.sharedKey
        : '';
    return courseId;
  }

  mounted() {
    if (window.storyteller.topContet?.$kind === 'CloudDesktopUpload') {
      this.desktopUploadFileAuto();
      window.next();
    }
  }

  // 主动上传，若未就绪则提示，不轮询
  async desktopUploadFile() {
    const { courseId } = this;
    const { fileName, src, desktopId } = this.content;
    desktopFileUpload.call(this, {
      fileName,
      desktopId,
      courseId,
      src
    });
  }

  // 默认上传，轮询直到开机后上传
  async desktopUploadFileAuto() {
    const { courseId } = this;
    const { fileName, src, desktopId } = this.content;
    const pollingInterval = 6;
    desktopFileUploadAuto.call(this, {
      fileName,
      desktopId,
      courseId,
      src,
      pollingInterval
    });
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  @apply relative flex items-center justify-between  sm:w-4/5 md:w-112 mt-10 ml-10;
  height: 64px;
  padding: 0 16px 0 8px;
  background: #f0f1f6;
  border-radius: 4px;
}
.text-wrapper {
  @apply flex items-center;
}
.button {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 32px;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  background: linear-gradient(270deg, #8b8eff 0%, #524eff 100%);
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.text {
  @apply mr-3 md:mr-7;
  display: -webkit-box;
  margin-left: 12px;
  overflow: hidden;
  color: #58517d;
  font-size: 16px;
  line-height: 22px;
  text-overflow: ellipsis;
  word-break: break-all;
  background: #f0f1f6;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
